const ORDER_TRIGGERS = ['order_created', 'order_updated', 'order_return_requested', 'order_return_approved'];

export const FLOW_VARIABLE_LIST = [
  { key: 'contact.name', label: 'FLOW_BUILDER.VARIABLES.CONTACT_NAME' },
  { key: 'contact.first_name', label: 'FLOW_BUILDER.VARIABLES.CONTACT_FIRST_NAME' },
  { key: 'contact.last_name', label: 'FLOW_BUILDER.VARIABLES.CONTACT_LAST_NAME' },
  { key: 'contact.email', label: 'FLOW_BUILDER.VARIABLES.CONTACT_EMAIL' },
  { key: 'contact.phone', label: 'FLOW_BUILDER.VARIABLES.CONTACT_PHONE' },
  { key: 'contact.id', label: 'FLOW_BUILDER.VARIABLES.CONTACT_ID' },
  { key: 'conversation.id', label: 'FLOW_BUILDER.VARIABLES.CONVERSATION_ID' },
  { key: 'agent.name', label: 'FLOW_BUILDER.VARIABLES.AGENT_NAME' },
  { key: 'event.data.id', label: 'FLOW_BUILDER.VARIABLES.EVENT_DATA_ID', triggers: ORDER_TRIGGERS },
  { key: 'event.data.external_id', label: 'FLOW_BUILDER.VARIABLES.EVENT_DATA_EXTERNAL_ID', triggers: ORDER_TRIGGERS },
  { key: 'event.data.order_number', label: 'FLOW_BUILDER.VARIABLES.EVENT_DATA_ORDER_NUMBER', triggers: ORDER_TRIGGERS },
  { key: 'event.data.total', label: 'FLOW_BUILDER.VARIABLES.EVENT_DATA_TOTAL', triggers: ORDER_TRIGGERS },
  { key: 'event.data.subtotal', label: 'FLOW_BUILDER.VARIABLES.EVENT_DATA_SUBTOTAL', triggers: ORDER_TRIGGERS },
  { key: 'event.data.financial_status', label: 'FLOW_BUILDER.VARIABLES.EVENT_DATA_FINANCIAL_STATUS', triggers: ORDER_TRIGGERS },
  { key: 'event.data.fulfillment_status', label: 'FLOW_BUILDER.VARIABLES.EVENT_DATA_FULFILLMENT_STATUS', triggers: ORDER_TRIGGERS },
  { key: 'event.data.items_count', label: 'FLOW_BUILDER.VARIABLES.EVENT_DATA_ITEMS_COUNT', triggers: ORDER_TRIGGERS },
  { key: 'event.data.tracking_number', label: 'FLOW_BUILDER.VARIABLES.EVENT_DATA_TRACKING_NUMBER', triggers: ['order_updated'] },
  { key: 'event.data.reverse_tracking_number', label: 'FLOW_BUILDER.VARIABLES.EVENT_DATA_REVERSE_TRACKING_NUMBER', triggers: ['order_return_approved'] },
  { key: 'event.data.reverse_tracking_url', label: 'FLOW_BUILDER.VARIABLES.EVENT_DATA_REVERSE_TRACKING_URL', triggers: ['order_return_approved'] },
  { key: 'event.data.reverse_carrier_name', label: 'FLOW_BUILDER.VARIABLES.EVENT_DATA_REVERSE_CARRIER_NAME', triggers: ['order_return_approved'] },
  { key: 'event.data.recovery_url', label: 'FLOW_BUILDER.VARIABLES.EVENT_DATA_RECOVERY_URL', triggers: ['cart_abandoned_created', 'cart_abandoned_updated'] },
];

export const FLOW_VARIABLE_LABELS = Object.fromEntries(
  FLOW_VARIABLE_LIST.map(v => [v.key, v.label])
);

// Keys restricted to specific triggers; others are always visible
export const TRIGGER_RESTRICTED_KEYS = new Set(
  FLOW_VARIABLE_LIST.filter(v => v.triggers).map(v => v.key)
);

export function getVariablesForTrigger(triggerEvent) {
  return FLOW_VARIABLE_LIST.filter(v => {
    if (!v.triggers) return true;
    return triggerEvent && v.triggers.includes(triggerEvent);
  });
}

export function extractJsonPaths(obj, prefix = '') {
  if (Array.isArray(obj)) {
    return obj.length > 0 ? extractJsonPaths(obj[0], prefix) : [];
  }
  if (!obj || typeof obj !== 'object') return prefix ? [prefix] : [];
  return Object.entries(obj).flatMap(([key, val]) => {
    const path = prefix ? `${prefix}.${key}` : key;
    if (val && typeof val === 'object') {
      return extractJsonPaths(val, path);
    }
    return [path];
  });
}
